
import sghTooltip from '@components/sgh-tooltip/sgh-tooltip.vue'
export default {
  name: 'RxDisclaimerTooltip',
  components: {
    sghTooltip,
  },
  props: {
    tooltipBoundingElement: {
      type: HTMLElement,
      default: null,
    },
  },
  data() {
    return {
      tooltipVisible: false,
      tooltipBounding: null,
    }
  },
  beforeUpdate() {
    this.tooltipBounding = this.tooltipBoundingElement
  },
  methods: {
    toggleTooltip() {
      this.tooltipVisible = !this.tooltipVisible
    },
    showTooltip() {
      this.tooltipVisible = true
    },
    hideTooltip() {
      this.tooltipVisible = false
    },
  },
}
